<template>
  <AlertMsg
    :msg="msgObj.msg"
    :show="msgObj.show"
    :role="msgObj.role"
    @closePopup="msgObj.show = false"
  ></AlertMsg>

  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary">
          <i class="fa-solid fa-cloud-arrow-up me-1"></i> Bulk Files Upload
        </h5>
      </div>
      <hr />

      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label">
            Class <sup><span class="text-danger">*</span></sup> :
          </label>

          <div class="dropdown">
            <button
              class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button"
              data-bs-toggle="dropdown"
            >
              {{ classList.find((c) => c._id === classID)?.name || "" }}
            </button>

            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="item in uniqueClassList" :key="item._id">
                <a
                  href="#"
                  class="dropdown-item"
                  @click.prevent="selectClass(item)"
                >
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label"
            >Section<sup><span class="text-danger">*</span></sup> :</label
          >
          <select
            v-model="sectionID"
            class="form-select form-select-sm"
            style="cursor: pointer"
          >
            <option value=""></option>
            <option v-for="s in secList" :key="s._id" :value="s._id">
              {{ s.Name }}
            </option>
          </select>
        </div>

        <div class="col-md-5">
          <!-- Upload row -->
          <div class="d-flex align-items-center gap-2">
            <label for="bulkFile" class="cursor-pointer">
              Upload<sup><span class="text-danger">*</span></sup
              >:
              <i class="fa fa-upload fs-5 ms-1"></i>
            </label>
            <div v-if="file" class="mt-2 d-flex align-items-center gap-2">
              <i class="fa fa-file-excel text-success"></i>
              <span class="small text-truncate">{{ file.name }}</span>
              <i
                class="fa-solid fa-x text-danger small cursor-pointer"
                role="button"
                @click="removeFile"
              ></i>
            </div>
            <button class="btn btn-sm btn-darknavy ms-2" @click="save">
              <i class="fa fa-save me-1"></i> Save
            </button>
            <button
              type="button"
              class="btn btn-sm btn-soft-dark"
              @click="reset()"
            >
              <i class="fas fa-times-circle me-1"></i> Cancel
            </button>
          </div>

          <!-- Selected file -->
          <!-- <div v-if="file" class="mt-2 d-flex align-items-center gap-2">
    <i class="fa fa-file-excel text-success"></i>
    <span class="small text-truncate">{{ file.name }}</span>
    <i
      class="fa-solid fa-x text-danger cursor-pointer"
      role="button"
      @click="removeFile"
    ></i>
  </div> -->

          <input
            id="bulkFile"
            type="file"
            class="d-none"
            accept=".csv,.xls,.xlsx"
            @change="onFileChange"
          />
        </div>
      </div>
      <div class="mt-2">
        <a
          href="#"
          class="text-primary text-decoration-none small"
          @click.prevent="download"
        >
          Sample Template </a
        ><br /><br />
        <strong>Date Format: DD/MM/YYYY</strong>
      </div>
      <ul v-if="Object.keys(errors).length" class="text-danger ps-3 mt-2">
        <li v-for="(err, key) in errors" :key="key">
          {{ err }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { schoolStore } from "@/utils/schoolStore";
import { api } from "@/utils/helpers";
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from "@/utils/validation.js";

const msgObj = ref({ msg: "", role: "", show: false });
const errors = ref({});
const store = schoolStore();

const classID = ref("");
const sectionID = ref("");
const file = ref(null);
const removeFile = () => {
  file.value = null;
  errors.value = {};

  const input = document.getElementById("bulkFile");
  if (input) input.value = "";
};

const classList = computed(() => {
  const list = store.clsList;
  return Array.isArray(list?.value)
    ? list.value
    : Array.isArray(list)
    ? list
    : [];
});

const uniqueClassList = computed(() => {
  const map = new Map();
  classList.value.forEach((cls) => {
    if (!cls?.name) return;
    const key = cls.name.trim().toLowerCase();
    if (!map.has(key)) map.set(key, cls);
  });
  return [...map.values()];
});

const secList = computed(() => {
  const list = store.secList;
  return Array.isArray(list?.value)
    ? list.value
    : Array.isArray(list)
    ? list
    : [];
});

const selectClass = (item) => {
  classID.value = item._id;
  sectionID.value = "";
};

const onFileChange = (e) => {
  const selected = e.target.files[0];
  if (!selected) return;

  const allowedExtensions = ["csv", "xls", "xlsx"];
  const fileExt = selected.name.split(".").pop().toLowerCase();

  if (!allowedExtensions.includes(fileExt)) {
    errors.value = {
      File: "Only CSV, XLS or XLSX files are allowed",
    };

    e.target.value = "";
    file.value = null;
    return;
  }

  errors.value = {};
  file.value = selected;
};

const download = () => {
  const url = process.env.VUE_APP_API_URL + "/images/templates/students.xlsx";

  const link = document.createElement("a");
  link.href = url;
  link.download = "students.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const reset = () => {
  classID.value = "";
  sectionID.value = "";
  file.value = null;

  errors.value = {};

  const input = document.getElementById("bulkFile");
  if (input) {
    input.value = "";
  }
  msgObj.value.show = false;
};

const save = async () => {
  const fields = {
    Class: { value: classID.value, validators: [isRequired] },
    Section: { value: sectionID.value, validators: [isRequired] },
    File: { value: file.value, validators: [isRequired] },
  };

  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length > 0) return;

  try {
    const formData = new FormData();
    formData.append("clsID", classID.value);
    formData.append("sectionID", sectionID.value);
    formData.append(file.value.name.split(".")[0], file.value);

    await api.post("/students/uploads", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    msgObj.value = {
      msg: "Added students successfully",
      role: "success",
      show: true,
    };
    file.value = null;

    sectionID.value = "";
  } catch (err) {
    console.log(err.response?.data);
  }
};
</script>

<style scoped>
.scrollable-menu {
  max-height: 200px;
  overflow-y: auto;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
